export default function (_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val, relOutpus) {
        var _a;
        env.collect('获取请求头 val: ', env === null || env === void 0 ? void 0 : env.headers);
        if (data.headerName) {
            outputs['rtn']((_a = env === null || env === void 0 ? void 0 : env.headers) === null || _a === void 0 ? void 0 : _a[data.headerName]);
        }
        else {
            outputs['rtn'](env === null || env === void 0 ? void 0 : env.headers);
        }
    });
}
